import { Activity } from 'lucide-react';
import ChartPlaceholder from './ChartPlaceholder';

export default function ChartSessions() {
  return (
    <ChartPlaceholder
      title="Session outcomes"
      icon={Activity}
      desc="Donut: completed / failed / stopped"
    />
  );
}
